import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const healthFundRoutesDictionary = moduleRouteDictionaryFactory(
  'healthFund',
  'health-funds',
  {
    list: 'list',
    detail: 'detail/:id',
  },
);
